import compose from 'lodash/flowRight'
import * as React from 'react'

import {withLocation} from '../../../routes'
import {withVisibility} from '../Visible/Visible.hocs'

import BuildsTimeline from './BuildsTimeline'

export default compose(withVisibility(false), withLocation, React.memo)(BuildsTimeline)
